<template>
  <v-dialog v-model="isVisible"
            no-click-animation
            max-width="50%">
    <v-card>
      <v-card-text>
        <v-layout>
          <v-flex v-if="rowItem">
            <v-progress-circular  indeterminate small
                                    color="primary" v-if="loading"></v-progress-circular>
            <span class="subheading" style="color: #333333;">{{ rowItem.memberId }} 資料量: {{ count }} 筆</span>
            <span class="subheading" style="color: red;" v-if="isBadCustomer">注意： {{ rowItem.memberId }} 為黑名單!</span>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex v-if="rowItem">
            <v-progress-circular  indeterminate small
                                  color="primary" v-if="loadingAssignor"></v-progress-circular>
            <span class="subheading" v-if="officialData && officialData.assignor && officialData.assignor!==''"
                  style="color: #333333;">讓與人：{{ officialData.assignor }} | 讓與人ID: {{ officialData.assignor_idno }}</span>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md6>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  dark
                  v-on="on">
                  進件 & 補資料 >>
                </v-btn>
              </template>
              <v-list>

                <v-list-tile :key="9" v-if="item.category !== 2 && isMaintain === true">
                  <v-list-tile-title>原融-系統維護中，若要進件請先上傳Line群組，謝謝</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="9" v-if="(getUserInfo.isFinanceOfficial === true || isAdmin || isStaff) &&
              item.category !== 2 && !item.displayId && platform === 0 && !isUpdateAction && isMaintain === false" @click="optionEvent(4)">
                  <v-list-tile-title>原融-上傳至裕富</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="9" v-if="item.category === 2 && !isUpdateAction && isMaintain === true">
                  <v-list-tile-title>商品貸-系統維護中，若要進件請先上傳Line群組，謝謝</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="9" v-if=" (getUserInfo.isFinanceOfficial === true || isAdmin || isStaff) &&
                item.category === 2 && !item.displayId && !isUpdateAction && isMaintain === false" @click="optionEvent(15)">
                  <v-list-tile-title>商品貸-上傳至裕富</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="9" v-if="item.displayId !== '' && item.caseStatus === 3 && !isUpdateAction" @click="optionEvent(29)">
                  <v-list-tile-title>優撥</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="0" v-if="!isUpdateAction" @click="optionEvent(0)">
                  <v-list-tile-title>申請書列印</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="1" v-if="(platform === 0 || platform === 3 ) && !isUpdateAction && getUserInfo.enableQueryCaseStatus" @click="optionEvent(25)">
                  <v-list-tile-title>新增保人(保1)</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="2" v-if="(isAdmin || isStaff || getUserInfo.enableAgentContract === true) && !isUpdateAction" @click="optionEvent(6)">
                  <v-list-tile-title>代辦合約書</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="3" v-if="(platform === 0 || platform === 3) && !isUpdateAction && getUserInfo.enableReCallout" @click="optionEvent(22)">
                  <v-list-tile-title>線上補照會時間</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="4" v-if="(platform === 0 || platform === 3) && !isUpdateAction && item.caseStatus === 3" @click="optionEvent(24)">
                  <v-list-tile-title>核准函</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="5" @click="optionEvent(2)">
                  <v-list-tile-title>圖片上傳</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="6" @click="optionEvent(3)">
                  <v-list-tile-title>PDF上傳</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex md6>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  dark
                  v-on="on">
                  轉換資料 >>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile :key="0" v-if="item.category !== 0 && !isUpdateAction" @click="optionEvent(32)">
                  <v-list-tile-title>轉原車</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="0" v-if="item.category !== 2 && !isUpdateAction" @click="optionEvent(16)">
                  <v-list-tile-title>轉CA</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="1" v-if="!isUpdateAction && platform !== 2" @click="optionEvent(12)">
                  <v-list-tile-title>轉中租</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="2" v-if="!isUpdateAction && platform !== 1" @click="optionEvent(11)">
                  <v-list-tile-title>轉和潤</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md6>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  dark
                  v-on="on">
                  案件調整 >>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile :key="0" v-if="(isAdmin || isStaff) && !isUpdateAction" @click="optionEvent(7)">
                  <v-list-tile-title>修改案件編號</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="1" v-if="!isUpdateAction" @click="optionEvent(10)">
                  <v-list-tile-title>修改經辦人</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="2" v-if="(isAdmin || isStaff) && !isUpdateAction" @click="optionEvent(30)">
                  <v-list-tile-title>變更專案代碼</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex md6>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  dark
                  v-on="on">
                  申覆&補件 >>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile :key="0" v-if="(platform === 0 || platform === 3 ) && !isUpdateAction && getUserInfo.enableRequestForExam" @click="optionEvent(21)">
                  <v-list-tile-title>線上案件申覆爭取</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="1" v-if="getUserInfo.enableRequestForExamSearch && !isUpdateAction || (isAdmin) " @click="optionEvent(23)">
                  <v-list-tile-title>案件申覆紀錄</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="2" v-if="(platform === 0 || platform === 3) && !isUpdateAction" @click="optionEvent(27)">
                  <v-list-tile-title>案件狀態變更紀錄</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="3" v-if="(platform === 0 || platform === 3) && !isUpdateAction" @click="optionEvent(28)">
                  <v-list-tile-title>案件撥款通知紀錄</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="4" v-if="isShowSearchBonus && !isUpdateAction" @click="optionEvent(26)">
                  <v-list-tile-title>強制查詢案件狀態</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="5" v-if="item.category === 0 || item.category === 3" @click="optionEvent(13)">
                  <v-list-tile-title>補保人(保2保3以上)</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>

            <br>
            <v-layout xs12 v-if="(platform === 0 || platform === 3 ) && !isUpdateAction">
              <v-flex xs6 v-if="getUserInfo.enableQueryCaseStatus">
                <v-text-field :label="`據點代號 (案件狀態查詢使用)`" v-model="dealer_branch_no"></v-text-field>
                <v-btn class="primary" dark text @click="optionEvent(19, dealer_branch_no)">線上案件狀態查詢</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md6>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  dark
                  v-on="on">
                  撥款流程 >>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile :key="0" v-if="(platform === 0 || platform === 3 ) && !isUpdateAction && getUserInfo.enableRequestPayment" @click="optionEvent(17)">
                  <v-list-tile-title>裕富線上請款</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="1" v-if="(platform === 0 || platform === 3 ) && !isUpdateAction" @click="optionEvent(18)">
                  <v-list-tile-title>裕富線上撥款狀態</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="2" v-if="!isUpdateAction" @click="optionEvent(8)">
                  <v-list-tile-title>對保資料上傳</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="3" v-if="!isUpdateAction" @click="optionEvent(1)">
                  <v-list-tile-title>其他表單</v-list-tile-title>
                </v-list-tile>

                <v-list-tile :key="4" v-if="!isUpdateAction && item.category !== 2" @click="optionEvent(5)">
                  <v-list-tile-title>動產抵押契約書</v-list-tile-title>
                </v-list-tile>
              </v-list>
              <br>
            </v-menu>
          </v-flex>
        </v-layout>

<!--        <v-layout xs12 v-if="(getUserInfo.isFinanceOfficial === true || isAdmin || isStaff) &&-->
<!--              item.category !== 2 && !item.displayId && platform === 0 && !isUpdateAction">-->
<!--          <v-flex v-if="isMaintain === true">-->
<!--            <v-btn color="red" dark text>原融-系統維護中，若要進件請先上傳Line群組，謝謝</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex v-if="isMaintain === false">-->
<!--            <v-btn class="primary" dark text @click="optionEvent(4)">原融-上傳至裕富</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="item.category === 2 && !isUpdateAction">-->
<!--          <v-flex v-if="isMaintain === true">-->
<!--            <v-btn color="red" dark text>商品貸-系統維護中，若要進件請先上傳Line群組，謝謝</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex v-if="isMaintain === false">-->
<!--            <v-btn class="primary" dark text @click="optionEvent(15)">商品貸-上傳至裕富</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <v-layout xs12 v-if="item.displayId !== '' && item.caseStatus === 3 && !isUpdateAction">-->
<!--          <v-flex>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(29)">優撥</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="(isAdmin || isStaff) && !isUpdateAction">-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(7)">修改案件編號</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(30)">變更專案代碼</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="!isUpdateAction">-->
<!--          <v-flex xs6>-->
<!--            <v-btn v-if="platform !== 1" class="primary" dark text @click="optionEvent(11)">轉和潤</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6>-->
<!--            <v-btn v-if="platform !== 2" class="primary" dark text @click="optionEvent(12)">轉中租</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12  v-if="item.category !== 2 && !isUpdateAction">-->
<!--          <v-flex>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(16)">轉CA</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="(isAdmin || isStaff || getUserInfo.enableAgentContract === true) && !isUpdateAction">-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(6)">代辦合約書</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6 v-if="item.category === 0 || item.category === 3">-->
<!--            <v-btn class="primary" dark text @click="optionEvent(13)">補保人</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="!isUpdateAction">-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(8)">案件對保資料</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6 v-if="item.category !== 2">-->
<!--            <v-btn class="primary" dark text @click="optionEvent(5)">動產抵押契約書</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="!isUpdateAction">-->
<!--          <v-flex xs6 v-if="item.category !== 2">-->
<!--            <v-btn class="primary" dark text @click="optionEvent(9)">案件設定</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(10)">修改經辦人</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="!isUpdateAction">-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(0)">列印</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(1)">其他表單</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12>-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(2)">圖片上傳</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(3)">PDF上傳</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="(platform === 0 || platform === 3 ) && !isUpdateAction">-->
<!--          <v-flex xs6 v-if="getUserInfo.enableQueryCaseStatus">-->
<!--            <v-btn class="primary" dark text @click="optionEvent(25)">新增保人</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="(platform === 0 || platform === 3 ) && !isUpdateAction">-->
<!--          <v-flex xs6 v-if="getUserInfo.enableRequestPayment">-->
<!--            <v-btn class="primary" dark text @click="optionEvent(17)">裕富線上請款</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(18)">裕富線上撥款狀態</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="(platform === 0 || platform === 3 ) && !isUpdateAction">-->
<!--          <v-flex xs6 v-if="getUserInfo.enableQueryCaseStatus">-->
<!--            <v-text-field :label="`據點代號 (案件狀態查詢使用)`" v-model="dealer_branch_no"></v-text-field>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(19, dealer_branch_no)">裕富線上案件狀態查詢</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="(platform === 0 || platform === 3 ) && !isUpdateAction">-->
<!--          <v-flex xs6 v-if="getUserInfo.enableRequestSupplement">-->
<!--            <v-btn class="primary" dark text @click="optionEvent(20)">裕富線上審件補件</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="(platform === 0 || platform === 3 ) && !isUpdateAction">-->
<!--          <v-flex xs6 v-if="getUserInfo.enableRequestForExam">-->
<!--            <v-btn class="primary" dark text @click="optionEvent(21)">裕富線上案件申覆爭取</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6 v-if="getUserInfo.enableRequestForExam && !isUpdateAction && (isAdmin || isStaff) ">-->
<!--            <v-btn class="primary" dark text @click="optionEvent(23)">裕富案件申覆紀錄</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="(platform === 0 || platform === 3) && !isUpdateAction">-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(27)">裕富線上案件狀態變更紀錄</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(28)">裕富線上案件撥款通知紀錄</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="(platform === 0 || platform === 3) && !isUpdateAction">-->
<!--          <v-flex xs6 v-if="getUserInfo.enableReCallout">-->
<!--            <v-btn class="primary" dark text @click="optionEvent(22)">裕富線上案件重新照會</v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs6 v-if="item.caseStatus === 3">-->
<!--            <v-btn class="primary" dark text @click="optionEvent(24)">核准通知書</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="isShowSearchBonus && !isUpdateAction">-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(26)">強制查佣</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
<!--        <v-layout xs12 v-if="rowItem && rowItem.approvedURL !== ''">-->
<!--          <v-flex xs6>-->
<!--            <v-btn class="primary" dark text @click="optionEvent(31)">核准函</v-btn>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--        <br>-->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark text @click="confirmEvent">關閉</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import common from '@/mixins/common';

export default {
  name: 'FinanceCreditDialog',
  props: {
    visible: Boolean,
    item: Object,
    platform: Number,
    rowItem: Object,
    isUpdateAction: Boolean
  },
  data() {
    return {
      loading: false,
      loadingAssignor: false,
      valid: true,
      dialog: false,
      isVisible:false,
      dealer_branch_no: '',
      items: [
        {
          action: 'local_activity',
          title: '測試',
          items: [
            { title: 'List Item' }
          ],
          active: true,
        },
      ],
      isBadCustomer: false,
      count: 0,
      officialData: null,
    };
  },
  watch:{
    visible(value){
      this.isVisible = value;
      if (this.rowItem){
        this.fetchAgentList().then(() => {
          const find = this.getAgentList.find(agent=>agent.agentId === this.rowItem.agentId);
          if (find){
            this.dealer_branch_no = find.dealerBranchNo ? find.dealerBranchNo : '0001';
          }
          console.log(`find agent == ${JSON.stringify(find)}`);
        });
        this.loadData();
        this.loadAssignorData();
      }
    },
    isVisible(value){
      if(!value)
      {
        this.$emit('closeEvent');
      }
    },
    item(value){
      console.log(`item == ${JSON.stringify(value)}`);
    },
    rowItem(value){
      console.log(`rowItem == ${JSON.stringify(value)}`);
    }
  },
  mixins: [common],
  computed:{
    ...mapGetters(['getUserInfo','getAgentList']),
    isShowSearchBonus() {
      if(!this.rowItem) {
        return false
      }
      return  this.rowItem.bonus === 0
    }
  },
  methods: {
    ...mapActions(['fetchAgentList', 'getFinanceSimpleList', 'getAssignorInfo']),
    optionEvent(eventKey, info){
      this.$emit('showEvent', { key: eventKey, info: info });
    },
    confirmEvent(){
      this.$emit('confirmEvent', true);
    },
    async loadData(){
      this.loading = true;
      this.isBadCustomer = false;
      this.count = 0;
      const res = await this.getFinanceSimpleList({ searchValue: this.rowItem.memberId});
      const result = res.data;
      if (result && result.statusCode === 0){
        for (let item of result.data){
          if (item.badCustomer === true){
            this.isBadCustomer = true;
            break;
          }
          this.count+=1;
        }
      }
      this.loading = false;
    },
    async loadAssignorData(){
      try {
        this.loadingAssignor = true;
        const res = await this.getAssignorInfo({ caseId: this.rowItem.caseId});
        const result = res.data;
        if (result && result.statusCode === 0){
          this.officialData = result.data;
        } else {
          this.officialData = null;
        }
      } catch (e) {
        console.log(`getAssignorInfo error `, e)
      } finally {
        this.loadingAssignor = false;
      }
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FinanceCreditDialog.vue